// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2_YjQ","col":"styles_col__14f7t","fulfillmentStatus":"styles_fulfillmentStatus__3lwYw","emailCol":"styles_emailCol__3rEyM"};